import React from 'react'
import { ContainerButton, ContainerModalError, ParagraphError, TitleError } from './styles'
import { Button } from '../Button'
import { PortalModal } from '~/components/shared/PortalModal'
import { IErrorModalProps } from '~/interfaces'
import { IconComponent } from '~/assets/icons/component'

export interface ModalErrorProps {
  showErrorModal: boolean
  onClose: () => void
  modalInfo: IErrorModalProps
}

export const ModalError: React.FC<ModalErrorProps> = ({
  showErrorModal,
  onClose,
  modalInfo: { title, subtitle, buttonMessage }
}: ModalErrorProps) => {
  if (!showErrorModal) return null

  return (
    <PortalModal
      size={'small'}
      useMask={false}
      show={showErrorModal}
      onClose={onClose}
      modalContainerProps={{
        style: { background: 'rgba(0, 0, 0, 0.3)' }
      }}
    >
      <ContainerModalError>
        <IconComponent name="attentionTriangle" iconsize={100} />
        <TitleError>{title}</TitleError>
        <ParagraphError>{subtitle}</ParagraphError>
        <ContainerButton>
          <Button onClick={onClose} data-testid="alert-development-modal-close-button" minWidth="small">
            {buttonMessage}
          </Button>
        </ContainerButton>
      </ContainerModalError>
    </PortalModal>
  )
}
